import React, { useState, useContext } from "react";
import "./Timeline.scss";
import StyleContext from "../../contexts/StyleContext";

const Timeline = ({ items }) => {
  const { isDark } = useContext(StyleContext);
  const [expandedItems, setExpandedItems] = useState({});

  // Sort items by date in descending order (most recent first)
  const sortedItems = [...items].sort((a, b) => {
    const dateA = new Date(a.startDate);
    const dateB = new Date(b.startDate);
    return dateB - dateA;
  });

  const toggleItem = (index) => {
    setExpandedItems({
      ...expandedItems,
      [index]: !expandedItems[index]
    });
  };

  return (
    <div className={`modern-timeline ${isDark ? "dark-mode" : ""}`}>
      {sortedItems.map((item, index) => (
        <div
          key={index}
          className={`timeline-entry ${expandedItems[index] ? 'expanded' : ''}`}
        >
          <div className="timeline-marker">
            <div className="timeline-dot"></div>
            <div className="timeline-line"></div>
          </div>

          <div className="timeline-card">
            <div className="timeline-header" onClick={() => toggleItem(index)}>
              <div className="timeline-logo-container">
                {item.logo && (
                  <img
                    src={item.logo}
                    alt={item.title}
                    className="timeline-logo"
                  />
                )}
              </div>

              <div className="timeline-content">
                <div className="timeline-title-row">
                  <h3 className="timeline-title">{item.title}</h3>
                  <span className="timeline-date">{item.date}</span>
                </div>
                <h4 className="timeline-subtitle">{item.subtitle}</h4>
              </div>

              <div className="timeline-toggle" aria-label={expandedItems[index] ? "Collapse" : "Expand"}>
                <span>{expandedItems[index] ? "−" : "+"}</span>
              </div>
            </div>

            {expandedItems[index] && (
              <div className="timeline-details">
                {item.description && (
                  <p className="timeline-description">{item.description}</p>
                )}

                {item.bullets && item.bullets.length > 0 && (
                  <div className="timeline-bullets-container">
                    <h5 className="timeline-section-title">Key Responsibilities</h5>
                    <ul className="timeline-bullets">
                      {item.bullets.map((bullet, i) => (
                        <li key={i}>{bullet}</li>
                      ))}
                    </ul>
                  </div>
                )}

                {item.projects && item.projects.length > 0 && (
                  <div className="timeline-projects">
                    <h5 className="timeline-section-title">Projects</h5>
                    {item.projects.map((project, i) => (
                      <div key={i} className="timeline-project">
                        <div className="project-header">
                          <h6 className="project-title">{project.name}</h6>
                          {project.date && <span className="project-date">{project.date}</span>}
                        </div>
                        <p className="project-description">{project.description}</p>
                      </div>
                    ))}
                  </div>
                )}

                {item.tags && item.tags.length > 0 && (
                  <div className="timeline-tags">
                    <h5 className="timeline-section-title">Skills</h5>
                    <div className="tags-container">
                      {item.tags.map((tag, i) => (
                        <span key={i} className="timeline-tag">{tag}</span>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Timeline;